import { useQueryClient } from 'react-query';
import { ProjectId } from 'api/models';
import { Project } from 'api/project';
import { getProjectMembersQueryKey } from 'queries';
import { ALL_PROJECTS_RM_QUERY_KEY } from 'queries/constants';
import {
  getPlaceholderResolutionByProjectQueryKeyV2,
  PlaceholderResolutionsQueryKey,
} from 'queries/placeholder';

const useInvalidateOldPlaceholderData = (project: Project) => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries(ALL_PROJECTS_RM_QUERY_KEY);

    queryClient.invalidateQueries(
      getProjectMembersQueryKey(ProjectId(project.projectId)),
    );
    queryClient.invalidateQueries(PlaceholderResolutionsQueryKey);
    queryClient.invalidateQueries(
      getPlaceholderResolutionByProjectQueryKeyV2(ProjectId(project.projectId)),
    );
  };
};

export { useInvalidateOldPlaceholderData };
